export const WIZARD_DELAYS = {
  BOT_TYPING: 800,
  SHORT: 500,
  MEDIUM: 800,
  LONG: 1600,
  VERY_LONG: 2400,
  EXTRA_LONG: 3600,
} as const;

export const COOLDOWN_HOURS = 12;
export const COOLDOWN_MS = COOLDOWN_HOURS * 60 * 60 * 1000;

export const MOBILE_BREAKPOINT = 768;
